import BPOINT from '@tradera/blueprint/theme/scss/export/breakpoints.module.scss';

// Explicit list of breakpoints for code completion
export enum BREAKPOINTS {
    XS = 'XS',
    SM = 'SM',
    MD = 'MD',
    LG = 'LG',
    XL = 'XL',
}

export type BreakpointWidth = {
    name: BREAKPOINTS;
    min: number;
    max: number;
};

export const BREAKPOINT_SIZES: Record<string, BreakpointWidth> =
    Object.fromEntries(
        Object.entries(BPOINT)
            .filter(([bp]) => BREAKPOINTS[bp as keyof typeof BREAKPOINTS])
            .map(([name, size], index, entries) => {
                const min = parseInt(size, 10);
                // Look ahead to next breakpoint entry and get its size minus one as current breakpoint's max size
                const max =
                    index + 1 in entries
                        ? parseInt(entries[index + 1][1], 10) - 1
                        : 99999;
                return [
                    name as keyof typeof BREAKPOINTS,
                    {
                        min,
                        max,
                        name: name as BREAKPOINTS,
                    },
                ];
            }),
    );
